import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import IconLink from 'components/Shared/IconLink/Index'

const EditModeLink = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <IconLink
      onClick={onClick}
      iconName='icon-edit'
      text={t('ticketPage.editModeLink')}
    />
  )
}

EditModeLink.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default EditModeLink
